import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { ProtocolDroidService } from '../protocol-droid/services/protocol-droid.service';

export type ToastDecoration = 'success' | 'error' | 'warning' | 'info';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  defaults: { [key in ToastDecoration]: any };

  constructor(private toastr: ToastrService, private protocolDroid: ProtocolDroidService) {
    this.defaults = {
      error: {
        message: 'misc.errors.unknown',
        messageDefault: 'An unknown error occurred. Please contact support.',
        title: 'misc.modals.error-title',
        titleDefault: 'Oops...'
      },
      success: {
        title: 'misc.modals.success-title',
        titleDefault: 'Congratulations'
      },
      warning: {
        title: 'misc.modals.warning-title',
        titleDefault: 'Warning'
      },
      info: {
        title: 'misc.modals.info-title',
        titleDefault: 'Information'
      }
    };
  }

  public showToast(
    decoration: ToastDecoration,
    options?: { title?: string; message?: string; messageDefault?: string; messageParams?: any }
  ): Promise<boolean> {
    let messageToast;
    this.toastr.toastrConfig.toastClass = decoration;
    const defaultDeco = this.defaults[decoration];
    const titleToast = options?.title || this.protocolDroid.translate(defaultDeco?.title, defaultDeco?.titleDefault) || '';

    if (!options?.message) {
      messageToast = this.protocolDroid.translate(defaultDeco?.message, defaultDeco?.messageDefault) || '';
    } else if (!options?.messageDefault) {
      messageToast = options?.message;
    } else {
      messageToast = this.protocolDroid.translate(options?.message, options?.messageDefault, options?.messageParams);
    }

    return new Promise((resolve: any) => {
      if (!this.toastr.findDuplicate(titleToast, messageToast, true, true)) {
        this.toastr.show(messageToast, titleToast).onShown = resolve(true);
      } else {
        resolve(true);
      }
    });
  }
}
